import cx from "classnames";
import React from "react";

import { selectLabel } from "../../pages/GdkMiddlewareRequestPage/gdkMiddlewarePageContent";
import * as styles from "./GdkMiddlewareDropdown.module.css";

export type GdkMiddlewareDropdownProps = {
  currentValue: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  children: React.ReactNode;
  disabled?: boolean;
};

export const GdkMiddlewareDropdown = ({
  currentValue,
  onChange,
  children,
  disabled,
}: GdkMiddlewareDropdownProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange && event.target.value !== "select") {
      onChange(event);
    }
  };
  return (
    <div className={styles.customSelectWrapper}>
      <select
        className={cx(styles.customSelect, disabled ? styles.disabled : "")}
        value={currentValue || ""}
        onChange={handleChange}
        disabled={disabled ?? false}
      >
        <option key="select" value="select" className={styles.selectDropdownLabel}>
          {selectLabel}
        </option>
        {children}
      </select>
    </div>
  );
};
